import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { Companies, ICompany } from '@/shared/model/company.model';
import { Rates } from '@/shared/model/company-rate.model';

const baseApiUrl = 'api/companies';

export default class CompanyService {
  public find(id: string): Promise<ICompany> {
    return new Promise<ICompany>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(Companies.from(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICompany): Promise<ICompany> {
    return new Promise<ICompany>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICompany): Promise<ICompany> {
    return new Promise<ICompany>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: ICompany): Promise<ICompany> {
    return new Promise<ICompany>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveCompanyRates(): Promise<Rates> {
    return new Promise<Rates>((resolve, reject) => {
      axios
        .get(baseApiUrl + '/rates')
        .then(res => {
          resolve(Rates.from(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdateCompanyRates(id: string, rates: Rates): Promise<ICompany> {
    return new Promise<ICompany>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${id}/rates`, rates)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
